import { render, staticRenderFns } from "./QuickStartSetting.vue?vue&type=template&id=740cc3ec"
import script from "./QuickStartSetting.vue?vue&type=script&lang=js"
export * from "./QuickStartSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports